import { type T, Translate } from '../../i18n/index';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { MaterialIcon } from '../icon/icons';
import { Icon } from '../icon/index';
import { addStyles } from '../theme';

export interface ImportButtonCtx {
	disabled?: boolean;
	title?: T;
	onclick?: (a?: Event) => void;
}

export const CSS = {
	container: 'c-Import-Button',
	MDL: {
		container: 'mdl-button mdl-button--accent mdl-button--fab',
	},
};

addStyles({
	[CSS.container]: {
		position: 'fixed',
		bottom: '160px',
		right: '8%',
		'z-index': 5,
	},
});

export const ImportButton = {
	view(ctx: ImportButtonCtx = {}): MithrilVNode {
		return m(
			'button',
			{
				className: `${CSS.container} ${CSS.MDL.container}`,
				disabled: ctx.disabled,
				title: Translate(ctx.title),
				onclick: ctx.onclick,
			},
			Icon.view(MaterialIcon.FILE_UPLOAD)
		);
	},
};
